<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uCknsv/tc-custom/9781429948005.jpg?1730984330205" alt="This image is the cover for the book River Road, Sentinels of New Orleans"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">River Road, Sentinels of New Orleans
      </h1>
      <p class="bookDescription body article font2">
        <b>Wizards, mermen, and pirates return in the second novel in the urban fantasy world “likely to remind readers of Charlaine Harris’s fun True Blood series” (<i>The Times-Picayune</i>).</b><br/><br/>Hurricane Katrina is long gone, but the preternatural storm rages on in New Orleans. New species from the Beyond moved into Louisiana after the hurricane destroyed the borders between worlds, and it falls to wizard sentinel Drusilla Jaco and her partner, Alex Warin, to keep the preternaturals peaceful and the humans unaware. But a war is brewing between two clans of Cajun merpeople in Plaquemines Parish, and down in the swamp, DJ learns, there’s more stirring than angry mermen and the threat of a were-gator.<br/><br/>Wizards are dying, and something—or someone—from the Beyond is poisoning the waters of the mighty Mississippi, threatening the humans who live and work along the river. DJ and Alex must figure out what unearthly source is contaminating the water and who—or what—is killing the wizards. Is it a malcontented merman, the naughty nymph, or some other critter altogether? After all, DJ’s undead suitor, the pirate Jean Lafitte, knows his way around a body or two.<br/><br/>It’s anything but smooth sailing on the bayou as the Sentinels of New Orleans series continues.<br/><br/><b>“An enchanting examination of magic and the people who wield it, <i>River Road</i> is a book to be savored. This second novel in the Sentinels of New Orleans series is a page-turner all by itself, but don’t cheat yourself by missing out on <i>Royal Street</i>, its predecessor.” —<i>RT Book Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Suzanne Johnson
      </h2>
      
      <p class="authorDescription body article"><P>SUZANNE JOHNSON is a magazine editor and feature writer with more than fifty national writing and editing awards. A longtime New Orleans resident, she helped rebuild for two years after Hurricane Katrina. <I>Royal Street</I> was her first novel and is the first book in an urban fantasy series about the Sentinels of New Orleans, wizards who guard the storied city against preternatural dangers.  As Susannah Sandlin, Suzanne is also the author of The Penton Vampire Legacy, a series of popular paranormal romances.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c11b5350